import React from 'react';
import BrandingFooter from '../common/BrandingFooter';
import LeagueTable from '../common/LeagueTable';
import { useWidgetLabels } from '../common/WidgetLabelsContext';

export default function TeamList({
  showBranding = false,
  competitionLabel = '',
  teams = [],
}) {
  const t = useWidgetLabels();

  return (
    <div className="w-full" style={{ background: 'var(--sw-bg)', color: 'var(--sw-text)' }}>
      <div
        className="px-4 py-2 text-xs font-bold uppercase tracking-wide border-b"
        style={{ borderColor: 'var(--sw-border)', color: 'var(--sw-muted)' }}
      >
        {competitionLabel} — {t('teamList')}
      </div>
      <div className="p-3">
        <LeagueTable rows={teams} emptyMessage={t('noData')} />
      </div>
      {showBranding && <BrandingFooter />}
    </div>
  );
}
